import {Banner} from '@primer/react'
import {useArchiveDialog, ARCHIVE_STATUS} from '../contexts/ArchiveDialogContext'

const ERROR_MESSAGES: Record<string, string> = {
  [ARCHIVE_STATUS.ERROR]: 'Failed to archive the session. Please try again.',
  [ARCHIVE_STATUS.ERROR_PR_CLOSE_FAILED]:
    'The session was archived, but the pull request could not be closed. Please close it manually.',
  [ARCHIVE_STATUS.ERROR_PR_REOPEN_FAILED]:
    'The session was unarchived, but the pull request could not be reopened. Please reopen it manually.',
  [ARCHIVE_STATUS.UNDO_ERROR]: 'Failed to unarchive the session. Please try again.',
}

export function ArchiveErrorBanner() {
  const {archiveStatus} = useArchiveDialog()

  const message = ERROR_MESSAGES[archiveStatus]
  if (!message) return null

  return <Banner variant="critical" title="Error" hideTitle description={message} />
}
